import React, {
  useEffect,
  useRef,
  useCallback,
  PropsWithChildren,
} from "react";
import clsx from "clsx";

interface ModalProps extends PropsWithChildren<any> {
  isOpen: boolean;
  onClose?: () => void;
  className?: string;
  styleSize?: string;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen = false,
  onClose,
  children,
  className,
  styleSize,
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const handleClickOutside = useCallback(
    (e: MouseEvent) => {
      if (
        isOpen &&
        onClose &&
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        onClose();
      }
    },
    [isOpen, onClose]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [handleClickOutside]);

  useEffect(() => {
    const body = document.body;
    if (isOpen) body.classList.add("overflow-hidden");
    else body.classList.remove("overflow-hidden");
  }, [isOpen]);

  if (!isOpen) return null;
  
  return (
    <div
      className={clsx(
        "fixed inset-0 z-50 flex items-center justify-center bg-black/40 transition-opacity duration-200"
      )}
    >
      <div
        ref={containerRef}
        className={clsx(
          "bg-white rounded-lg shadow-lg transform transition-all duration-200 scale-95 animate-modal-in",
          styleSize || "max-w-lg", // tamanho padrão
          className
        )}
      >
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
};
